import type * as React from 'react'

/**
 * A keycap. Flat — a shadow on an 18px chip reads as noise, and the border
 * already separates it from the text it sits in.
 */
export function Kbd(p: { children: React.ReactNode }) {
  return (
    <kbd className="inline-flex h-5 min-w-5 items-center justify-center rounded-xs border border-line bg-s3 px-1.5 font-mono text-[11px] leading-none font-medium text-muted">
      {p.children}
    </kbd>
  )
}
